define("shared/helpers/has-item", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.hasItem = hasItem;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f
  /**
   * Takes a set and a value and returns if the set has the value
   *
   * @method has-item
   */

  function hasItem(_ref) {
    let [set, item] = _ref;
    return set.has(item);
  }
  const hasItemHelper = (0, _helper.helper)(hasItem);
  var _default = _exports.default = hasItemHelper;
});